import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { I18nService } from '@core/services/i18n.service';
import { StorageService } from '@core/services/storage.service';
import { AuthService, UsersService } from '@services/index';
import { UserInfoModel } from '@shared/models/users.model';
import { Observable } from 'rxjs';
import { first, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class TokenGuard implements CanActivate {

  constructor(
    private authService: AuthService,
    private router: Router,
    private storageService: StorageService,
    private usersService: UsersService,
    private i18nService: I18nService
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> {
    /*
    * !! UYARI !! : BURADAKİ İŞLEMLER TÜM PROJE ANGULAR'A GEÇİLDİĞİNDE PASİF HALE GETİRİLİP ANGULAR PROJESİ ÜZERİNDEN GİRİŞ YAPILACAKTIR...
    */
    const deppParams = Object.assign({}, route.queryParams);
    delete deppParams.page;

    const sessionKey = (this.storageService.get('SessionKey') && this.storageService.get('SessionKey') === route.params.token);
    if (sessionKey) {
      this.router.navigate([route.queryParams.page], { queryParams: deppParams });
      return;
    } else {
      const userInfo = { Email: '', IsDeveloper: false, Name: '', RoleType: 0, LicenceType: '' };
      this.storageService.set('SessionKey', route.params.token);
      this.usersService.userSubject.next(userInfo);

      return this.usersService.getUserInfo().pipe(
        first(),
        map((data: UserInfoModel) => {
          if (data) {
            data.user.LicenseType = data.licenseType;
            this.usersService.userSubject.next(data.user);
            this.storageService.set('user', JSON.stringify(data.user));
            this.i18nService.language = route.params.language;
            this.router.navigate([route.queryParams.page], { queryParams: deppParams });
            return true;
          } else {
            this.authService.logout();
            return;
          }
        })
      );
    }
  }
}
